import { UserAvatar } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px 16px;
  cursor: pointer;

  &[data-has-border='true'] {
    padding-top: 8px;
    border-top: 1px solid #eaeaea;
  }
`
export const StyledAvatar = styled(UserAvatar)`
  margin-right: 8px;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 40px;
    object-fit: cover;
  }
`
export const StyledInputWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 16px;
  border: 1px solid #eaeaea;
  height: 48px;
  padding: 5px 16px;
  width: calc(100% - 48px);

  &[data-show-full='true'] {
    width: 100%;
  }
`
export const StyledInputIcon = styled.div`
  margin-right: 16px;
`
export const StyledInputText = styled.div`
  font-size: 14px;
  color: #9495a0;
`
